/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];


export const SortOrder = {
  Descending: 'Descending',
  Ascending: 'Ascending',
} as const;
